import WithSeguimientoMonitoreoProvider from "./WithSeguimientoMonitoreoProvider";

const MonitoreoSeguridad = ()=>{
    return (<WithSeguimientoMonitoreoProvider soloUnidades={true} esSeguimientoMonitoreo={false}/>)
}
export default MonitoreoSeguridad;